module.exports = __webpack_public_path__ + "img/globe-solid.1848a4df.svg";